import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { spacing, variant } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import styled from 'styled-components';
import { Box } from '../../primitives/Box/Box.es.js';

const chipGroupDirectionStyles = variant({
  prop: "direction",
  compoundProp: "isChipsFillGroupWidth",
  variants: {
    horizontal: {
      flexDirection: "row",
      true: {
        "& > div": {
          flex: "1 1 auto"
        }
      }
    },
    vertical: {
      flexDirection: "column",
      justifyContent: "flex-start",
      false: {
        alignItems: "center"
      },
      true: {
        alignItems: "stretch"
      }
    }
  }
});
const ChipGroup = styled(Box)`
    display: flex;
    ${chipGroupDirectionStyles};

    --gap: ${({ gutter = "xs" }) => spacing(gutter)};

    margin: calc(-1 * var(--gap)) 0 0 calc(-1 * var(--gap));
    width: calc(100% + var(--gap));

    & > div {
        margin: var(--gap) 0 0 var(--gap);
    }
`;

export { ChipGroup };
//# sourceMappingURL=styled.es.js.map
